import PropTypes from 'prop-types'
import React from 'react'
import _isFunction from 'lodash/isFunction'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Watch, { WATCH_RENDER_TYPE_OVERLAY_LINK } from 'components/Watch'
import Link from 'components/Link'
import { URL_GAIA_PLUS } from 'services/url/constants'
import { getBoundActions } from 'actions'
import MoreInfo from 'components/MoreInfo'
import WatchAccess, {
  ACCESS_CHECK_AUTH_FEATURE_GEO,
  ACCESS_FEATURE,
  ACCESS_PREVIEW,
} from 'components/WatchAccess'
import WatchAccessAllowed from 'components/WatchAccessAllowed'
import { Map } from 'immutable'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'

function getBackgroundImage (image) {
  const style = {
    backgroundImage: `url(${image})`,
  }
  return style
}

function getClassName (vertical) {
  const className = ['tile-hero']
  if (vertical) {
    className.push('tile-hero--vertical')
  }
  return className.join(' ')
}
function getPlayClass (showMoreInfo, auth) {
  const className = ['tile-hero__play']
  if (showMoreInfo) {
    className.push('tile-hero__play--more-info')
  }
  if (!auth.get('jwt')) {
    className.push('tile-hero__play--anonymous')
  }
  return className.join(' ')
}

function TileHero (props) {
  const {
    id,
    auth,
    preview,
    feature,
    image,
    type,
    url,
    className,
    showMoreInfo,
    heroLabel,
    toolTipComponent,
    hasPlayIcon,
    upstreamContext,
    displayMoreInfoButton,
    itemIndex,
    onClickWatch,
    vertical = false,
    upgradeToWatch,
    upgradeToWatchLabel,
    forceAccess,
    asShare,
    title,
  } = props

  const withProps = (f) => (_isFunction(f) ? () => f(props) : null)

  // set the series featured episode data
  const playEventData = Map.isMap(upstreamContext) ? upstreamContext.getIn(['playEventData'], Map()) : Map()
  const hasMediaId = playEventData.get('mediaId', false)
  let tileHeroUpstreamContext = upstreamContext
  if (Map.isMap(playEventData) && playEventData.size > 0 && !hasMediaId) {
    tileHeroUpstreamContext = upstreamContext
      .setIn(['playEventData', 'mediaId'], feature.get('id', 0))
      .setIn(['playEventData', 'content_id'], id)
      .setIn(['playEventData', 'content_name'], title)
  }

  return (
    <div className={getClassName(vertical)}>
      <Watch
        asShare={asShare}
        className={className ? [`tile-hero__link ${className}`] : ['tile-hero__link']}
        url={url}
        auth={auth}
        feature={feature}
        preview={preview}
        forceAccess={forceAccess}
        style={getBackgroundImage(image)}
        renderType={WATCH_RENDER_TYPE_OVERLAY_LINK}
        upstreamContext={tileHeroUpstreamContext}
        itemIndex={itemIndex}
        onClickWatch={withProps(onClickWatch)}
        type={type}
        title={title}
      >
        {upgradeToWatch && <div className="tile-hero--overlay" />}
        {heroLabel ? <span className="tile-hero__label">{heroLabel}</span> : null}
        {upgradeToWatch ? (
          <Link
            className={getPlayClass(showMoreInfo, auth)}
            title={upgradeToWatchLabel}
            to={URL_GAIA_PLUS}
          >
            <IconV2
              className="tile-hero__padlock"
              type={ICON_TYPES.PADLOCK}
            />
          </Link>
        ) : null}
        {hasPlayIcon && !upgradeToWatch ? (
          <WatchAccess
            auth={auth}
            preview={preview}
            feature={feature}
            accessCheck={ACCESS_CHECK_AUTH_FEATURE_GEO}
          >
            <WatchAccessAllowed onClick={withProps(onClickWatch)}>
              <span role="presentation" className={getPlayClass(showMoreInfo, auth)}>
                <IconV2
                  className="tile-hero__play-icon"
                  type={ICON_TYPES.PLAY}
                />
              </span>
            </WatchAccessAllowed>
          </WatchAccess>
        ) : null}
      </Watch>
      {showMoreInfo ? (
        <WatchAccess
          auth={auth}
          preview={preview}
          feature={feature}
          accessCheck={ACCESS_CHECK_AUTH_FEATURE_GEO}
        >
          <WatchAccessAllowed>
            {
              displayMoreInfoButton !== false
                && <MoreInfo
                  showToolTip={!!toolTipComponent}
                  vertical={vertical}
                  url={url}
                />
            }
          </WatchAccessAllowed>
        </WatchAccess>
      ) : null}
      {toolTipComponent}
    </div>
  )
}

TileHero.propTypes = {
  asShare: PropTypes.bool,
  className: PropTypes.array,
  image: PropTypes.string.isRequired,
  active: PropTypes.bool,
  url: PropTypes.string.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  hasPlayIcon: PropTypes.bool,
  preview: ImmutablePropTypes.map.isRequired,
  feature: ImmutablePropTypes.map.isRequired,
  showMoreInfo: PropTypes.bool.isRequired,
  toolTipComponent: PropTypes.element,
  onClickWatch: PropTypes.func,
  upstreamContext: ImmutablePropTypes.map,
  heroLabel: PropTypes.string,
  upgradeToWatch: PropTypes.bool,
  forceAccess: PropTypes.oneOf([
    ACCESS_FEATURE,
    ACCESS_PREVIEW,
  ]),
  title: PropTypes.string,
  pageUrl: PropTypes.string,
  id: PropTypes.number,
}

export default compose(
  connectRedux(
    (state) => ({
      pageUrl: state.page.get('path'),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
      }
    },
  ),
)(TileHero)
